import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
// import { NotificationContainer, NotificationManager } from "react-notifications";
import { resetPassword } from 'actions';
import Alert from '@material-ui/lab/Alert';
import { FETCH_ERROR } from 'constants/ActionTypes';

const ResetPassword = (props) => {
  sessionStorage.clear()
  const [otp, setOTP] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState(null);
  const [cpassword, setCPassword] = useState(null);
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const { loading, message, error } = useSelector(({ commonData }) => commonData);

  useEffect(() => {

    if (token !== null) {
      props.history.push('/');
    }
  }, [token]);


  return (
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3 md-6">
      <div className="app-login-main-content">

        <div className="app-logo-content d-flex align-items-center justify-content-center">
          <Link className="logo-lg" to="/" title="FVS">
            <img style={{ paddingBottom: 5 }} src={require("assets/images/logo.jpg")} alt="FVS" title="FVS" />
            <br />
            <span style={{ fontSize: 16, color: "#fff" }}>
              <center><IntlMessages id="app.name" /></center>
            </span>
          </Link>
        </div>

        <div className="app-login-content">
          <div className="app-login-header mb-6">
            <h1>{
              message &&
              <Alert severity="success">{message}</Alert>
              ||
              <IntlMessages id="appModule.changePassword" />
            }
            </h1>
            <h1>{
              error &&
              <Alert severity="error">{error}</Alert>
              ||
              null
            }
            </h1>
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>

                <TextField
                  label="Username"
                  fullWidth
                  onChange={(event) => setEmail(event.target.value)}
                  defaultValue={email}
                  margin="dense"
                  variant="outlined"
                  className="mt-1 my-sm-3"
                />

                <TextField
                  label="Enter Code"
                  fullWidth
                  onChange={(event) => setOTP(event.target.value)}
                  defaultValue={otp}
                  margin="dense"
                  variant="outlined"
                  className="mt-1 my-sm-3"
                />

                <TextField
                  type="password"
                  label="New Password"
                  fullWidth
                  onChange={(event) => setPassword(event.target.value)}
                  defaultValue={password}
                  margin="dense"
                  variant="outlined"
                  className="mt-1 my-sm-3"
                />

                <TextField
                  type="password"
                  label="Confirm Password"
                  fullWidth
                  onChange={(event) => setCPassword(event.target.value)}
                  defaultValue={cpassword}
                  margin="dense"
                  variant="outlined"
                  className="mt-1 my-sm-3"
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button
                    onClick={() => {
                      if (password != cpassword) {
                        //alert("Password Mismatch")
                        dispatch({ type: FETCH_ERROR, payload: 'Password Mismatch' });
                      } else {
                        dispatch(resetPassword({ email, otp, password }));
                      }

                    }}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    {
                      loading &&
                      <CircularProgress size={20} />
                      ||
                      <IntlMessages id="appModule.changePassword" />
                    }
                  </Button>
                  <Link to="/"  className="btn btn-success">
                    <IntlMessages id="appModule.signIn" />
                  </Link>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>

      {/* {message && NotificationManager.error(message)}
      <NotificationContainer /> */}
    </div>
  );
};


export default ResetPassword;
